import { message } from "antd";

export default (obj) => {
  try {
    const text = JSON.stringify(obj, null, 2); // format đẹp
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        // message.success("Copied to clipboard!");
        message.open({
          type: "success",
          content: "Copied to clipboard!",
          duration: 3, // auto close sau 3s
        });
        setTimeout(() => message.destroy(), 2000);
      }).catch(err => {
        message.open({
          type: "error",
          content: "Failed to copy!",
          duration: 3,
        });
        setTimeout(() => message.destroy(), 2000);
      });
    } else {
      // fallback
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand("copy");
        message.open({
          type: "success",
          content: "Copied to clipboard!",
          duration: 3,
        });
        setTimeout(() => message.destroy(), 2000);
      } catch (err) {
        message.open({
          type: "error",
          content: "Failed to copy!",
          duration: 3,
        });
        setTimeout(() => message.destroy(), 2000);
      }
      document.body.removeChild(textarea);
    }
  } catch (e) {
    message.open({
      type: "error",
      content: "Invalid JSON object!",
      duration: 3,
    });
    setTimeout(() => message.destroy(), 2000); // tự tắt sau 2s
  }
}
